module.exports = __webpack_public_path__ + "static/media/bileductcancer.3db7869b.svg";